var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAccountOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6574 5L6 5L6 23L19.6574 23L19.6574 5ZM6 4L5 4L5 5L5 23L5 24L6 24L19.6574 24L20.6574 24V23.9099L20.7166 23.947L24.5398 17.8367L25.0186 17.0715L24.116 17.0715L20.6574 17.0715L20.6574 5L20.6574 4L19.6574 4L6 4ZM20.6574 18.0715L20.6574 22.1564L23.2133 18.0715L20.6574 18.0715ZM16.9732 10.6667L7.76301 10.6667L7.76301 9.66675L16.9732 9.66675L16.9732 10.6667ZM7.76301 13.5239L16.9732 13.5239L16.9732 12.5239L7.76301 12.5239L7.76301 13.5239ZM11.4471 16.3811L7.76301 16.3811L7.76301 15.3811L11.4471 15.3811L11.4471 16.3811Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountOrder);
export default __webpack_public_path__ + "static/media/MyAccountOrder.d0c07dd13f153195155491051270870d.svg";
export { ForwardRef as ReactComponent };